import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Chips } from 'primereact/chips';
import { confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';


import Header from '@components/Header';

import { editInformationCompany } from '@actions/business';
import { sendActionToBitacora  } from '@actions/bitacora';

import { getValueLanguageObj } from '@utils/general'


class EditCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      btnSubmitLoading: false,
      companyId: '',
      nameCompany: '',
      clave: '',
      country: '',
      justification: '',
      errors: [],
    };
  }

  componentDidMount() {
    const { history } = this.props
    if(!history.location.state?.id) return history.push('/business')
    this.setState({
      companyId: history.location.state?.id,
      nameCompany: history.location.state?.nombre,
      clave: history.location.state?.clave,
      country: history.location.state?.pais
    })
    return this.setState({ loadingPage: false });
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t } = this.props;
    const { nameCompany, clave, justification } = this.state;
    let errors = {};
    if (!nameCompany) errors = { ...errors, 'nameCompany': `${t('Nombre')} ${t('es requerido')}`  }
    if (!clave) errors = { ...errors, 'clave': `${t('Clave')} ${t('es requerido')}`  }
    if (!justification) errors = { ...errors, 'justification': `${t('Justificación del cambio')} ${t('es requerido')}`  }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, t, editInformationCompany, sendActionToBitacora } = this.props
    const { companyId, nameCompany, clave, justification } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const response = await editInformationCompany({ companyId, nameCompany, clave, justification })
    if (!response.status) {
      const dataBitacora = {
        transactionName: 'actEmpresa',
        reason: `${nameCompany} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => history.push('/business'),
        onHide: () => history.push('/business')
      });
    }
    return this.setState({ btnSubmitLoading: false });
  };

  render() {
    const { t, history } = this.props;
    const { loadingPage, nameCompany, clave, country, justification, btnSubmitLoading, errors } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    if (loadingPage) return true;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header
            title={t("Editar Empresa")}
            linkText={t("Ir al listado")}
            to="/business"
          />
        </div>
        <div className="p-col-12">
          <div className="card">
            <form onSubmit={this.onSubmit} autoComplete="false">
              <div className="p-fluid p-grid p-mb-4">
              <div className="p-col-12 p-field">
                  <label className="p-text-bold p-pb-2">
                    {t('Pais')}
                  </label>
                  <br/>
                  <label>
                    {getValueLanguageObj(country)}
                  </label>
                </div>
                <div className="p-col-12 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {t('Nombre')}
                  </label>
                  <InputText
                    name="nameCompany"
                    type="text"
                    value={nameCompany}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`nameCompany`),
                    })}
                  />
                  {getFormErrorMessage(`nameCompany`)}
                </div>
                <div className="p-col-12 p-field">
                  <label htmlFor="title" className="p-text-bold p-pb-2">
                    {t('Clave')}
                  </label>
                  <InputText
                    name="clave"
                    type="text"
                    value={clave}
                    onChange={this.onChange}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`clave`),
                    })}
                  />
                  {getFormErrorMessage(`clave`)}
                </div>
                <div className="p-col-12 p-field">
                  <label htmlFor="title" className="p-text-bold">
                    {t('Justificación del cambio')}
                  </label>
                  <InputTextarea
                    name="justification"
                    onChange={this.onChange}
                    value={justification}
                    rows={5}
                    cols={30}
                    className={classNames({
                      'p-invalid': isFormFieldValid(`justification`),
                    })}
                  />
                  {getFormErrorMessage(`justification`)}
                </div>
              </div>
              <div className="p-col-12 footer-btn">
                <div className="p-d-flex p-jc-between">
                  <Button
                    label={t('Cancelar')}
                    type="button"
                    className="p-button-secondary"
                    onClick={() => history.push('/business')}
                  />
                  <Button
                    label={t('Actualizar Empresa')}
                    type="submit"
                    className="p-button-primary"
                    loading={btnSubmitLoading}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: state.catalogs.countriesCurrentCatalog,
});

const mapDispatchToProps = {
  editInformationCompany,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(EditCompany);
